import React from 'react';
import { Desktop } from './Desktop';

function App() {
  return (
    <div>
      <Desktop />
    </div>
  );
}

export default App;
